import { createContext } from 'react';

export const defaultRoof = {
  roof: {},
  setRoof: (roof) => {},
};

export const RoofContext = createContext(defaultRoof);
